import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { EventEmitter, ElementRef, Component, Inject, Input, Output, HostListener, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { mixinHideEvent, mixinShowEvent, mixinClearEvent, mixinInputEvent, mixinChangeEvent, mixinBlurEvent, mixinFocusEvent, mixinFormControl, FadvBaseComponent, createFormControlProvider, Forward, Track, formControlValueInput, formControlDisabledInput, formControlValueOutput, focusEventOutput, blurEventOutput, changeEventOutput, inputEventOutput, clearEventOutput, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/autocomplete/autocomplete';

class FadvAutocompleteComponent extends mixinHideEvent(mixinShowEvent(mixinClearEvent(mixinInputEvent(mixinChangeEvent(mixinBlurEvent(mixinFocusEvent(mixinFormControl(FadvBaseComponent)))))))) {
    constructor(el) {
        super(el);
        this.autocapitalize = undefined;
        /* The input's autofocus attribute. */
        this.autofocus = false;
        /* Adds a clear button when the input is populated */
        this.clearable = false;
        this.inputmode = undefined;
        /* The input's maximum value. */
        this.max = 255;
        /* The maximum length of input that will be considered valid. */
        this.maxLength = 255;
        /* The input's minimum value. */
        this.min = 0;
        /* The minimum length of input that will be considered valid. */
        this.minLength = 0;
        /* A pattern to validate input against. */
        this.pattern = '';
        /* Makes the input a required field. */
        this.required = false;
        /* Enables spell checking on the input. */
        this.spellcheck = false;
        /* The input's name attribute. */
        this.name = '';
        /* The input's label. */
        this.label = '';
        this.placeholder = '';
        /* The input's help text. */
        this.helpText = '';
        /* This will be true when the control is in an invalid state.
         */
        this.invalid = false;
        /* Makes the input readonly. */
        this.readonly = false;
        /** When true the input will have a floating label, when false the label will be centered able the input */
        this.floating = true;
        this.suggestions = [];
        this.selected = new EventEmitter();
    }
    handleEnterPress(event) {
        const input = event.target;
        const parentForm = input.closest('form');
        if (parentForm === null || parentForm === void 0 ? void 0 : parentForm.contains(input)) {
            parentForm.requestSubmit();
        }
    }
    handleSelectEvent(event) {
        this.selected.emit(event.detail.item.value);
    }
    ngAfterContentInit() {
        this.registerFormValueChangeHandler((value) => {
            this.elementRef.nativeElement.value = value;
        });
        this.registerSubscription(this.blurred, () => this.onTouched());
        this.registerSubscription(this.inputChanged, () => this.reportChange(this.elementRef.nativeElement.value));
        this.registerSubscription(this.changed, () => this.reportChange(this.elementRef.nativeElement.value));
    }
    select() {
        var _a, _b;
        (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.select();
    }
    setRangeText(replacement, start, end, selectMode) {
        var _a, _b;
        (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.setRangeText(replacement, start, end, selectMode);
    }
    setSelectionRange(selectionStart, selectionEnd, selectionDirection) {
        var _a, _b;
        (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
    }
}
FadvAutocompleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAutocompleteComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvAutocompleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvAutocompleteComponent, selector: "fadv-autocomplete", inputs: { value: "value", disabled: "disabled", autocapitalize: "autocapitalize", autofocus: "autofocus", clearable: "clearable", inputmode: "inputmode", max: "max", maxLength: "maxLength", min: "min", minLength: "minLength", pattern: "pattern", required: "required", spellcheck: "spellcheck", variant: "variant", name: "name", label: "label", placeholder: "placeholder", helpText: "helpText", valid: "valid", invalid: "invalid", readonly: "readonly", floating: "floating", pill: "pill", suggestions: "suggestions" }, outputs: { valueChange: "valueChange", focused: "focused", blurred: "blurred", changed: "changed", inputChanged: "inputChanged", cleared: "cleared", selected: "selected" }, host: { listeners: { "keydown.enter": "handleEnterPress($event)", "sl-select": "handleSelectEvent($event)" } }, providers: [createFormControlProvider(FadvAutocompleteComponent)], usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "autocapitalize", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "autofocus", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "clearable", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "inputmode", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "max", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "maxLength", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "min", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "minLength", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "pattern", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "required", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "spellcheck", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "variant", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "name", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "label", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "placeholder", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "helpText", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "valid", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "invalid", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "readonly", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "floating", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "pill", void 0);
__decorate([
    Forward()
], FadvAutocompleteComponent.prototype, "suggestions", void 0);
__decorate([
    Track()
], FadvAutocompleteComponent.prototype, "selected", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAutocompleteComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-autocomplete',
                    template: '<ng-content></ng-content>',
                    providers: [createFormControlProvider(FadvAutocompleteComponent)],
                    inputs: [formControlValueInput, formControlDisabledInput],
                    outputs: [formControlValueOutput, focusEventOutput, blurEventOutput, changeEventOutput, inputEventOutput, clearEventOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { autocapitalize: [{
                type: Input
            }], autofocus: [{
                type: Input
            }], clearable: [{
                type: Input
            }], inputmode: [{
                type: Input
            }], max: [{
                type: Input
            }], maxLength: [{
                type: Input
            }], min: [{
                type: Input
            }], minLength: [{
                type: Input
            }], pattern: [{
                type: Input
            }], required: [{
                type: Input
            }], spellcheck: [{
                type: Input
            }], variant: [{
                type: Input
            }], name: [{
                type: Input
            }], label: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], helpText: [{
                type: Input
            }], valid: [{
                type: Input
            }], invalid: [{
                type: Input
            }], readonly: [{
                type: Input
            }], floating: [{
                type: Input
            }], pill: [{
                type: Input
            }], suggestions: [{
                type: Input
            }], selected: [{
                type: Output
            }], handleEnterPress: [{
                type: HostListener,
                args: ['keydown.enter', ['$event']]
            }], handleSelectEvent: [{
                type: HostListener,
                args: ['sl-select', ['$event']]
            }] } });

class FadvAutocompleteModule {
}
FadvAutocompleteModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAutocompleteModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvAutocompleteModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvAutocompleteModule, declarations: [FadvAutocompleteComponent], imports: [FadvCommonModule], exports: [FadvAutocompleteComponent] });
FadvAutocompleteModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAutocompleteModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAutocompleteModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvAutocompleteComponent],
                    imports: [FadvCommonModule],
                    exports: [FadvAutocompleteComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvAutocompleteComponent, FadvAutocompleteModule };
